import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { UserPredictionModel } from '../models/user-prediction.model';
import { UserDataChangesEndpoint } from '../constants/user-data-changes-endpoint';

@Injectable({
  providedIn: 'root',
})
export class UserPredictionsListService {
  constructor(private http: WrapperHttpService) {}

  getUserPredictionsList(searchCriteria: { filter: string }): Observable<UserPredictionModel[]> {
    const url =
      `${API_URL}${UserDataChangesEndpoint.Base}${UserDataChangesEndpoint.Users}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<UserPredictionModel[]>(url);
  }
}
